export { default } from './StockistMap'
